import React from 'react';
import BasicLink from '../web-component-wrappers/BasicLink';

const AppealNotFound = () => (
  <>
    <h1>Sorry, we couldn’t find that appeal.</h1>
    <BasicLink
      disable-analytics
      path="/your-claims"
      text="Go back to your claims and appeals"
    />
  </>
);

export default AppealNotFound;
